module.exports = __webpack_public_path__ + "img/kangyang2.5856526b.png";